(function () {
    'use strict';
    $(document).ready(function () {

        // $.get('https://wykresy-sniezka2021.lkwadrat3.nazwa.pl/gpw/sniezka/graph.php?a=stock', function (data){
        //     $('header .rate .value').text(data[0].stock + ' zł');
        // });

        // Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
        });

        //Clicked outside of element
        window.clickedOutside = function (targetToClose, callback, _excludes = []) {
            const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
            const $target = $(targetToClose);

            if (typeof callback !== "function") {
                console.error('Callback has to be a function!');
                return null;
            }

            $('body').on('click', function (e) {
                const clickedElement = e.target;
                const isTargetVisible = $target.css('display') !== 'none';
                const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
                const isClickedElementTarget = $target.is(clickedElement);
                const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

                if (
                    isTargetVisible &&
                    !isClickedElementExcluded &&
                    !isClickedElementTarget &&
                    isClickedElementATargetChild
                ) {
                    callback($target, excludes);
                }
            });
        }

        function closeSearch() {
            $('.search-trigger').removeClass('active');
            $('.search-panel').fadeOut();
        }

        clickedOutside('.search-panel', closeSearch, ['.search-trigger']);

        // Object fit IE11 polyfill
        objectFitImages();
    });
}(jQuery));
